const APPOINTMENT_REQUEST_TYPES = {
  REPORT: 'report',
  REQUEST: 'request'
};
export default APPOINTMENT_REQUEST_TYPES;
